import React from 'react';

export default function ({ feedItem, eleRef }) {
    return (

<div className="uploadmilestone_content">
                            <div className="content-view-milestone">
                              <div className='imgFrame'>
                                <a href='https://parenting.firstcry.com/memories/milestones' className="add_photo R16_9e">
                                <div className="icon addphotoIcon gtm-add-photo" data-icon-font="x"></div><div className='gtm-add-photo'>Add Photo</div>
                                </a>
                                <img src={(feedItem.data[0].frameImage)?feedItem.data[0].frameImage:''} alt="logo" className='gtm-add-photo'/>
                              </div>
                              <div className="button-view_milestone">
                                <a href='https://parenting.firstcry.com/memories/milestones'>
                                  <button className="M16_white" type="button">upload milestone</button>
                                  </a>
                              </div>
                            </div>
                        </div>

    )
}
